import { createSlice } from "@reduxjs/toolkit";

const initialCrmDashboardState = {
  listLoading: false,
  actionsLoading: false,
  entities: {
    avarage_instalation: {
      current: 0,
      previous: 0,
    },
    avarage_instalation_residential: {
      current: 0,
      previous: 0,
    },
    avarage_instalation_mahasiswa: {
      current: 0,
      previous: 0,
    },
    total_reject: {
      current: 0,
      previous: 0,
    },
    total_installed: {
      current: 0,
      previous: 0,
    },
    total_dismantle: {
      current: 0,
      previous: 0,
    },
    total_migrasi: {
      current: 0,
      previous: 0,
    },
  },
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const crmDashboardSlice = createSlice({
  name: "crmDashboard",
  initialState: initialCrmDashboardState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    crmDashboardFetched: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
    },
  },
});
